// extracted by mini-css-extract-plugin
export default {"payerNameWrapper":"style_payerNameWrapper__bdq9P","payerBankInfo":"style_payerBankInfo__ZRQsz","rateTypes":"style_rateTypes__kSjwe"};